import React from 'react';
import CCAmexImage from '../../../shared/img/cc-amex.png';
import CCMasterCardImage from '../../../shared/img/cc-mastercard.png';
import CCVisaImage from '../../../shared/img/cc-visa.png';
import CCDiscoverImage from '../../../shared/img/cc-discover.png';
import { CreditCardTypeEnum } from '../../../../services/V2/gozer';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

const CCImage = ({ token, className }) => {
    if(!token) return <>CC</>
    switch (token.cardType) {
        case CreditCardTypeEnum.AMERICAN_EXPRESS:
            return <img className={className} src={CCAmexImage} alt="American Express" />
        case CreditCardTypeEnum.DISCOVER:
            return <img className={className} src={CCDiscoverImage} alt="Discover" />
        case CreditCardTypeEnum.MASTER_CARD:
            return <img className={className} src={CCMasterCardImage} alt="Master Card" />
        case CreditCardTypeEnum.VISA:
            return <img className={className} src={CCVisaImage} alt="Visa" />
        default:
            return <AccountBalanceIcon
                className={className}
                style={{ marginRight: ".5em" }}
                height={25} />
    }
}

export default CCImage;